// import "./Herosection.css";
// import { useState, useEffect, useCallback, useRef } from "react";
// import { useProducts } from "../../../context/ProductsContext";
// import { getImageUrl } from '../../../utils/imageUtils';

// export default function Herosection() {
//     const { productsdata, loading, error } = useProducts();

//     const [images, setImages] = useState([]);
//     const [currentIndex, setCurrentIndex] = useState(0);
//     const [isPaused, setIsPaused] = useState(false);
//     const intervalRef = useRef(null);
//     const [isLargeScreen, setIsLargeScreen] = useState(false);


//     useEffect(() => {
//         if (productsdata && productsdata.length > 0) {
//             const shuffled = [...productsdata].sort(() => 0.5 - Math.random());
//             const maxItems = Math.min(10, productsdata.length);
//             const selectedProducts = shuffled.slice(0, maxItems);

//             const selectedImages = selectedProducts
//                 .map(product => {
//                     const imagePath = product.mainImage || product.mainimg || (product.images && product.images[0]) || '';
//                     return getImageUrl(imagePath);
//                 })
//                 .filter(img => img !== '');

//             setImages(selectedImages);
//         }
//     }, [productsdata]);

//     const totalImages = images.length;

//     const goToNext = useCallback(() => {
//         if (totalImages === 0) return;
//         setCurrentIndex((prev) => (prev + 1) % totalImages);
//     }, [totalImages]);

//     const goToPrev = useCallback(() => {
//         if (totalImages === 0) return;
//         setCurrentIndex((prev) => (prev - 1 + totalImages) % totalImages);
//     }, [totalImages]);

//     const goToIndex = useCallback((index) => {
//         if (index < 0 || index >= totalImages) return;
//         setCurrentIndex(index);
//     }, [totalImages]);

//     useEffect(() => {
//         if (totalImages > 1 && !isPaused) {
//             intervalRef.current = setInterval(goToNext, 4000);
//         }
//         return () => {
//             if (intervalRef.current) clearInterval(intervalRef.current);
//         };
//     }, [totalImages, isPaused, goToNext]);

//     // الكشف عن حجم الشاشة وتجميع الصور في أزواج للشاشات الكبيرة
//     useEffect(() => {
//         const mediaQuery = window.matchMedia('(min-width: 1200px)');
//         setIsLargeScreen(mediaQuery.matches);

//         const handleChange = (e) => {
//             setIsLargeScreen(e.matches);
//             setCurrentIndex(0); // إعادة تعيين عند تغيير حجم الشاشة
//         };

//         mediaQuery.addEventListener('change', handleChange);
//         return () => mediaQuery.removeEventListener('change', handleChange);
//     }, []);

//     const handlePause = useCallback(() => setIsPaused(true), []);
//     const handleResume = useCallback(() => setIsPaused(false), []);

//     if (loading) {
//         return (
//             <div className="hero-section">
//                 <div className="hero-loading">⏳ جاري تحميل المنتجات...</div>
//             </div>
//         );
//     }

//     if (!productsdata || productsdata.length === 0) {
//         return (
//             <div className="hero-section">
//                 <div className="hero-loading">
//                     {error ? `❌ خطأ في تحميل البيانات: ${error.message}` : "لا توجد منتجات لعرضها حالياً في السلايدر"}
//                 </div>
//             </div>
//         );
//     }

//     if (images.length === 0) {
//         return (
//             <div className="hero-section">
//                 <div className="hero-loading">لا توجد صور لعرضها.</div>
//             </div>
//         );
//     }

//     return (
//         <div className="hero-section">
//             <div className="hero-slide">
//                 <img
//                     src={images[currentIndex]}
//                     alt={`Slide ${currentIndex + 1}`}
//                     className="hero-image"
//                     onError={(e) => {
//                         console.error(`❌ فشل تحميل الصورة رقم ${currentIndex + 1}:`, images[currentIndex]);
//                         e.target.src = '';
//                     }}
//                 />
//             </div>

//             {totalImages > 1 && (
//                 <>
//                     <div className="hero-dots">
//                         {images.map((_, idx) => (
//                             <button
//                                 key={idx}
//                                 className={`hero-dot ${idx === currentIndex ? "active" : ""}`}
//                                 onClick={() => goToIndex(idx)}
//                                 // ✅ تم إزالة onMouseEnter/onMouseLeave من النقاط
//                                 aria-label={`انتقل إلى الصورة ${idx + 1}`}
//                             />
//                         ))}
//                     </div>

//                     {/* ✅ تم إضافة onMouseEnter/onMouseLeave إلى الأزرار الجانبية فقط */}
//                     <button
//                         className="hero-arrow-left"
//                         onClick={goToPrev}
//                         onMouseEnter={handlePause}
//                         onMouseLeave={handleResume}
//                         aria-label="السابق"
//                     >
//                         <span className="hero-arrow-icon-left">❮</span>
//                     </button>

//                     <button
//                         className="hero-arrow-right"
//                         onClick={goToNext}
//                         onMouseEnter={handlePause}
//                         onMouseLeave={handleResume}
//                         aria-label="التالي"
//                     >
//                         <span className="hero-arrow-icon-right">❯</span>
//                     </button>
//                 </>
//             )}
//         </div>
//     );
// }













































import "./Herosection.css";
import { useState, useEffect, useCallback, useRef } from "react";
import { useProducts } from "../../../context/ProductsContext";
import { getImageUrl } from '../../../utils/imageUtils';

export default function Herosection() {
    const { productsdata, loading, error } = useProducts();

    const [images, setImages] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const intervalRef = useRef(null);
    const [isLargeScreen, setIsLargeScreen] = useState(false);

    useEffect(() => {
        if (productsdata && productsdata.length > 0) {
            const shuffled = [...productsdata].sort(() => 0.5 - Math.random());
            const maxItems = Math.min(10, productsdata.length);
            const selectedProducts = shuffled.slice(0, maxItems);

            const selectedImages = selectedProducts
                .map(product => {
                    const imagePath = product.mainImage || product.mainimg || (product.images && product.images[0]) || '';
                    return getImageUrl(imagePath);
                })
                .filter(img => img !== '');

            setImages(selectedImages);
        }
    }, [productsdata]);

    const totalImages = images.length;

    // ✅ الحل السحري: تجميع الصور بناءً على حجم الشاشة
    const displaySlides = isLargeScreen
        ? images.reduce((acc, _, i) => {
            if (i % 2 === 0) acc.push(images.slice(i, i + 2)); // تجميع كل صورتين معاً
            return acc;
        }, [])
        : images.map(img => [img]); // صورة واحدة في مصفوفة للشاشات الصغيرة

    const totalSlides = displaySlides.length;

    const goToNext = useCallback(() => {
        if (totalSlides === 0) return;
        setCurrentIndex((prev) => (prev + 1) % totalSlides);
    }, [totalSlides]);

    const goToPrev = useCallback(() => {
        if (totalSlides === 0) return;
        setCurrentIndex((prev) => (prev - 1 + totalSlides) % totalSlides);
    }, [totalSlides]);

    const goToIndex = useCallback((index) => {
        if (index < 0 || index >= totalSlides) return;
        setCurrentIndex(index);
    }, [totalSlides]);

    useEffect(() => {
        if (totalSlides > 1 && !isPaused) {
            intervalRef.current = setInterval(goToNext, 4000);
        }
        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [totalSlides, isPaused, goToNext]);

    // الكشف عن حجم الشاشة
    useEffect(() => {
        const mediaQuery = window.matchMedia('(min-width: 1200px)');
        setIsLargeScreen(mediaQuery.matches);

        const handleChange = (e) => {
            setIsLargeScreen(e.matches);
            setCurrentIndex(0); // إعادة تعيين عند تغيير حجم الشاشة
        };

        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, []);

    const handlePause = useCallback(() => setIsPaused(true), []);
    const handleResume = useCallback(() => setIsPaused(false), []);

    if (loading) {
        return (
            <div className="hero-section">
                <div className="hero-loading">⏳ جاري تحميل المنتجات...</div>
            </div>
        );
    }

    if (!productsdata || productsdata.length === 0) {
        return (
            <div className="hero-section">
                <div className="hero-loading">
                    {error ? `❌ خطأ في تحميل البيانات: ${error.message}` : "لا توجد منتجات لعرضها حالياً في السلايدر"}
                </div>
            </div>
        );
    }

    if (images.length === 0) {
        return (
            <div className="hero-section">
                <div className="hero-loading">لا توجد صور لعرضها.</div>
            </div>
        );
    }

    return (
        <div className="hero-section">
            <div className="hero-slide">
                {/* ✅ عرض صورة أو صورتين بناءً على حجم الشاشة */}
                {displaySlides[currentIndex]?.map((img, idx) => (
                    <img
                        key={`${currentIndex}-${idx}`}
                        src={img}
                        alt={`Slide ${currentIndex * (isLargeScreen ? 2 : 1) + idx + 1}`}
                        className="hero-image"
                        onError={(e) => {
                            console.error(`❌ فشل تحميل الصورة:`, img);
                            e.target.src = '';
                        }}
                    />
                ))}
            </div>

            {totalSlides > 1 && (
                <>
                    <div className="hero-dots">
                        {displaySlides.map((_, idx) => (
                            <button
                                key={idx}
                                className={`hero-dot ${idx === currentIndex ? "active" : ""}`}
                                onClick={() => goToIndex(idx)}
                                aria-label={`انتقل إلى الشريحة ${idx + 1}`}
                            />
                        ))}
                    </div>

                    <button
                        className="hero-arrow-left"
                        onClick={goToPrev}
                        onMouseEnter={handlePause}
                        onMouseLeave={handleResume}
                        aria-label="السابق"
                    >
                        <span className="hero-arrow-icon-left">❮</span>
                    </button>

                    <button
                        className="hero-arrow-right"
                        onClick={goToNext}
                        onMouseEnter={handlePause}
                        onMouseLeave={handleResume}
                        aria-label="التالي"
                    >
                        <span className="hero-arrow-icon-right">❯</span>
                    </button>
                </>
            )}
        </div>
    );
}